import React from 'react';
import { IonButton, IonInput, isPlatform } from "@ionic/react";
import ModalHeader from './ModalHeader';
import './GoogleMap.scss'
import Api from '../services/Api';
declare var google: any;

interface ComponentProps {
  lat: number,
  lng: number,
  zoom: number,
  height: number;
  placeName: string,
  fixedMarker: boolean;
  saveMap?: Function,
  closeModal?: Function
}

interface ComponentState {
  placeName: string;
  movedMap: boolean;
  disabled: boolean;
}

export default class GoogleMap extends React.Component<ComponentProps, ComponentState>  {
  api = Api.getInstance();

  private readonly mapRef: any;
  private map: any;

  constructor(props: ComponentProps) {
    super(props);
    this.mapRef = React.createRef();
    let disabled = true;
    let movedMap = false;
    if (this.props.placeName && this.props.placeName.length > 2) {
      disabled = false;
      movedMap = true;
    }
    this.state = {
      placeName: this.props.placeName,
      disabled: disabled,
      movedMap: movedMap
    }
  }

  componentDidMount() {
    if (isPlatform('ios')) {
      setTimeout(() => {
        this.loadMap();
      }, 200);
    } else {
      this.loadMap();
    }
  }

  loadMap = () => {
    const latLng = new google.maps.LatLng(this.props.lat, this.props.lng);

    const mapOptions = {
      center: latLng,
      zoom: this.props.zoom,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
      clickableIcons: true,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
      callback: Function.prototype

    };

    this.map = new google.maps.Map(this.mapRef.current, mapOptions);

    this.map.addListener('center_changed', () => {
      if (!this.state.movedMap) {
        this.setState({ 
          movedMap: true 
        })
      }
    });

    if (!this.props.fixedMarker) {
      const marker = new google.maps.Marker({
        map: this.map,
        animation: google.maps.Animation.DROP,
        position: latLng,
        icon: 'assets/icon/pin_selector.svg',
        title: this.props.placeName,
      });

      if (this.props.placeName) {
        const infoContent = '<div style="padding: 5px">' + this.state.placeName + '</div>';
        const infoWindow = new google.maps.InfoWindow({
          content: infoContent
        });
        infoWindow.open(this.map, marker);
      }
    }
  }

  private handlePlaceName = (event: any) => {
    const placeName = event.target.value;
    const disabled = placeName.length > 2 ? false : true;
    this.setState({
      placeName: placeName, 
      disabled: disabled
    });
  }

  private closeModal = () => {
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  }

  saveMap = () => {
    if (this.props.saveMap) {
      const zoom = this.map.zoom;
      const lat = this.map.center.lat();
      const lng = this.map.center.lng();
      this.props.saveMap(lat, lng, zoom, this.state.placeName);
    }
  }

  render() {

    const pinTop = 'calc(' + this.props.height / 2 + 'vh - 50px)';
    const moveMessageTop = 'calc(' + this.props.height / 2 + 'vh - 100px)';
    let middleX = window.innerWidth / 2
    if (middleX > 300) {
      middleX = 300
    }
    const pinLeft = (middleX - 17) + 'px'
    const messageLeft = (middleX - 110) + 'px'

    return (
      <div className="fullWidth">
        <div 
          ref={this.mapRef} 
          style={{ height: this.props.height + "vh"}}></div>
        {
          this.props.fixedMarker &&
          <img alt="pin"
            style={{
              height: "50px",
              width: "34px",
              position: "absolute",
              top: pinTop,
              left: pinLeft,
              zIndex: 1001
            }}
            src="assets/icon/pin_selector.svg"/>
        }
        {
          (this.props.fixedMarker && !this.state.movedMap) &&
          <div style={{
            height: "46px",
            width: "220px",
            backgroundColor: "#fff",
            color: "#c00",
            borderRadius: "8px",
            position: "absolute",
            top: moveMessageTop,
            left: messageLeft,
            padding: "4px",
            textAlign: "center",
            zIndex: 1001
          }}>
            {this.api.tr('move_marker')}
          </div>
        }
        {
          this.props.saveMap &&
            <section className="saveMap safe_padding_bottom">
              <div className="saveMap__wrap">
                <div className="flex items-center mx-4">
                  <div className="pt-2">
                    <img 
                      className="mx-2" 
                      alt="pin" 
                      src="assets/icon/pin.svg"
                      />
                    {this.api.tr('place')}
                  </div>
                  <div>
                    <IonInput 
                      placeholder={this.api.tr('position_description')}
                      className="input_default border_gray mt-4"
                      value={this.state.placeName} 
                      onIonChange={this.handlePlaceName}/>
                  </div>
                </div>
                <IonButton 
                  disabled={this.state.disabled || !this.state.movedMap} 
                  expand="block" className="mt-4"
                  onClick={this.saveMap}>
                  {this.api.tr('save')}
                </IonButton>
              </div>
            </section>
        }
      </div>
    )
  }

}
